import Vue from 'vue'
import { matchAnyLike, orderBy } from 'oderon-commons/src/utils'
import { Org, Client, Vehicle, go } from '@/models'
import BoltBookmarks from './BoltBookmarks'

export default new Vue({
  data() {
    return {
      allOrgs: [],
      allClients: [],
      allVehicles: [],
      allCameras: []
    }
  },
  computed: {
    allItems() {
      let result = []

      for (let r of this.allOrgs) {
        result.push({
          label: r.name,
          to: '/orgs/' + r.id,
          icon: 'business',
          keyfields: [r.name, r.label],
          details: [`orgId=${r.id}`]
        })
      }

      for (let r of this.allClients) {
        // Encontra o veículo que está associado com este
        // módulo. Isto depende da tabela Vehicles estar
        // consistente.
        //
        // Em DEV isto funciona, e o inverso não (i.é, achar
        // pelo orgId+idInOrg, porque os jobs acabam estragando
        // a sincronização).
        let vehicle = this.allVehicles.find((x) => {
          return x.clientId == r.id
        })

        let vcode = vehicle && vehicle.code
        if (vcode == null) vcode = r.vehicleCode
        let extraCode = vehicle && vehicle.extraCode
        let tags = vehicle && vehicle.tags

        result.push({
          label: [
            r.id.toString(),
            vcode || '(sem placa)',
            {
              text: extraCode,
              cssClass: 'grey--text'
            }
          ],
          to: '/clients/' + r.id,
          icon: 'mdi-developer-board',
          keyfields: [r.id, vcode, extraCode],
          rightLabel: r.orgName,
          tags,
          details: [
            `vehicleId=${vehicle && vehicle.id}`,
            `orgId=${r.orgId}`,
            `idInOrg=${vehicle && vehicle.idInOrg}`
          ]
        })
      }

      for (let r of this.allVehicles) {
        // Os veículos que possuem módulos provavelmente foram
        // absorvidos nos itens acima, então só precisamos incluir
        // itens para veículos sem módulo.
        //
        // NB: O link neste caso vai direto pra home do
        // veículo-sem-módulo.
        if (r.clientId == null) {
          result.push({
            label: [r.code, r.extraCode],
            to: '/vehicles/' + r.id,
            icon: 'mdi-car',
            keyfields: [r.code, r.extraCode],
            rightLabel: r.org.name,
            tags: r.tags,
            details: [
              `vehicleId=${r.id}`,
              `orgId=${r.org.id}`,
              `idInOrg=${r.idInOrg}`
            ]
          })
        }
      }

      for (let r of this.allCameras) {
        result.push({
          label: [r.name, r.imei, r.vehicle && r.vehicle.code],
          to: '/setup/cameras/' + r.id,
          icon: 'mdi-projector',
          keyfields: [r.name, r.imei, r.vehicle && r.vehicle.code]
        })
      }

      // NB: Se keywords está null, todos os bookmarks serão
      // exibidos. Se não estiver, será feita a busca apenas no
      // label do bookmark (por falta de outra opção)
      for (let item of BoltBookmarks.items) {
        result.push({
          ...item,
          keyfields: [item.label]
        })
      }

      return result
    }
  },
  methods: {
    async fetchData() {
      const [allOrgs, allClients, allVehicles, allCameras] = await Promise.all([
        this.fetchOrgs(),
        this.fetchClients(),
        this.fetchVehicles(),
        this.fetchCameras()
      ])

      Object.assign(this, { allOrgs, allClients, allVehicles, allCameras })
    },

    async fetchOrgs() {
      let orgs = await Org.findAll({ mini: true })
      return orderBy(orgs, [['label', 'asc']])
    },

    async fetchClients() {
      return await Client.findMini()
    },

    async fetchVehicles() {
      return await Vehicle.findMini()
    },

    async fetchCameras() {
      // NB: 2026-03-04 Este é o único acesso à API de câmeras
      // que não está no "componente de câmeras" (views/setup/cameras)
      // let res = await Camera.findAll({ mini: true })
      let res = await go.get('/cameras')
      return res.rows
    },

    filterItems(keywords) {
      if (keywords == null || keywords.trim().length < 1) {
        return BoltBookmarks.items
      }

      let rows = this.allItems
        .filter((r) => matchAnyLike(keywords, ...r.keyfields))
        .slice(0, 8)

      let hbItem = this.checkHbItem(keywords)
      if (hbItem != null) rows.push(hbItem)

      let tripItems = this.checkTripItems(keywords)
      if (tripItems != null) rows.push(...tripItems)

      return rows
    },

    checkHbItem(keywords) {
      // \s = space, \S = not space
      let m = keywords.toLowerCase().match(/hb\s*(\d+)/)
      if (m) {
        return {
          label: 'Heartbeat ' + m[1],
          to: '/heartbeats/' + m[1],
          icon: 'mdi-heart'
        }
      }
    },

    checkTripItems(keywords) {
      let m = keywords.toLowerCase().match(/^(\S+)\s+(\d+)$/)
      if (m) {
        let orgs = this.allOrgs.filter((o) => matchAnyLike(m[1], o.name))
        return orgs.map((o) => {
          return {
            label: `Trip ${m[2]} in org ${o.name}`,
            to: `/orgs/${o.name}/trip/${m[2]}`,
            icon: 'mdi-road-variant'
          }
        })
      }
    }
  }
})
